module.exports = {
  ContractSplitMediaEntity (entity) {
    return contractSplitMediaEntity(entity)
  }
}

const uuid = require("uuid")

const dayjs = require("dayjs")

const contractSplitMediaEntity = (entity) => {
  return {
    splitMediaId: entity.splitMediaId ?? uuid.v4(),
    append: entity.append || "",
    category: entity.category || "",
    contractId: entity.contractId || 0,
    contractMediaId: entity.contractMediaId || 0,
    contractMedia_Id: entity.contractMedia_Id || null,
    dates: [dayjs(entity.startDate).format("YYYY-MM-DD"), dayjs(entity.endDate).format("YYYY-MM-DD")],
    endDate: entity.endDate || null,
    format: entity.format || "",
    grossItemSum: entity.grossItemSum || 0,
    grossRate: entity.grossRate || 0,
    id: entity.id || 0,
    isBonus: entity.isBonus || false,
    isToBeConfirmed: entity.isToBeConfirmed || false,
    loading: entity.loading || 0,
    mediaEndDate: entity.mediaEndDate || entity.endDate,
    mediaName: entity.mediaName || "",
    mediaStartDate: entity.mediaStartDate || entity.startDate,
    mediaTotalInternalSplit: entity.mediaTotalInternalSplit || 0,
    nettItemSum: entity.nettItemSum || 0,
    noOfDays: entity.noOfDays || 0,
    operator: entity.operator || "",
    productionTotalInternalSplit: entity.productionTotalInternalSplit || 0,
    quantity: entity.quantity || 0,
    rateOption: entity.rateOption || "",
    serviceFee: entity.serviceFee || 0,
    startDate: entity.startDate || null,
    totalProductionCost: entity.totalProductionCost || 0,
    unitProductionCost: entity.unitProductionCost,
    unitQty: entity.unitQty || 1,
    unitRate: entity.unitRate || 0,
    mediaPlan: entity.mediaPlan || "",
    unitRateOptionObject: entity.unitRateOptionObject || "",
    mediaSnap:entity.mediaSnap || null,
    prodCostSplit:entity.prodCostSplit || null,
    
  }
}
